<template>
  <span class="inline-flex items-center gap-0.5" :title="title">
    <span
      v-for="i in 4"
      :key="i"
      class="w-1.5 h-1.5 rounded-full"
      :class="i <= strength ? filledClass : 'bg-gray-200 dark:bg-gray-600'"
    ></span>
  </span>
</template>

<script setup>
import { computed } from 'vue'

// SRS word strength, 0 (not enrolled) … 4 (long-interval). Mirrors
// VocabReview#strength on the server.
const props = defineProps({
  strength: { type: Number, default: 0 },
})

const LABELS = ['New', 'Learning', 'Growing', 'Strong', 'Mastered']

const title = computed(() => `Word strength: ${LABELS[Math.min(Math.max(props.strength, 0), 4)]}`)
// One hue for every filled dot. Mastery is conveyed by all four being filled;
// a second colour at strength 4 either collided with the amber that means
// "due for review" (bg-amber-400) or, as emerald-700, rendered dimmer than
// emerald-500 in dark mode and inverted the ramp.
const filledClass = 'bg-emerald-500'
</script>
